import { render, staticRenderFns } from "./cardV2.vue?vue&type=template&id=50083b9c&scoped=true"
import script from "./cardV2.vue?vue&type=script&lang=js"
export * from "./cardV2.vue?vue&type=script&lang=js"
import style0 from "./cardV2.vue?vue&type=style&index=0&id=50083b9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50083b9c",
  null
  
)

export default component.exports